import { fetchHil } from "../utils";

export default {
  namespaced: true,
  state: {
    staff: [],
    selectables: {}
  },
  mutations: {
    setStaff(state, staff) {
      state.staff = staff;

      state.selectables.staff = staff
        .filter(({ trigram }) => trigram != null)
        .map(({ firstName, lastName, trigram, email }) => ({
          text: `${trigram} - ${
            lastName
              ? firstName
                ? `${firstName} ${lastName}`
                : lastName
              : email
          }`,
          value: trigram
        }));
    }
  },
  actions: {
    async fetchStaff({ commit }) {
      const resp = await (await fetchHil(`/partner/staff`)).json();
      commit("setStaff", resp);
    }
  }
};
